import React from 'react';
import { Button } from './ui/button';

const MeetShannon = () => {
  return (
    <section className="bg-white py-20 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-serif text-[#0A2540] font-bold text-center mb-16">
          Meet Shannon Brooks
        </h2>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left Image */}
          <div className="flex justify-center lg:justify-end">
            <div className="w-full max-w-md rounded-lg overflow-hidden shadow-xl">
              <img 
                src="https://customer-assets.emergentagent.com/job_sbrooks-expansion/artifacts/3xfcildt_Image20260318161004.png" 
                alt="Shannon Brooks"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          {/* Right Content */}
          <div className="space-y-8">
            <div>
              <h3 className="text-2xl md:text-3xl font-serif text-[#0A2540] font-bold mb-6">
                Your Financial Services Specialist
              </h3>
              <p className="text-base md:text-lg text-[#2C3E50] leading-relaxed mb-4">
                Shannon Brooks is the founder and principal of Brooks & Associates LLC, serving as a dedicated Financial Services Specialist. As a wife and mother, Shannon brings both personal integrity and professional excellence to her work.
              </p>
              <p className="text-base md:text-lg text-[#2C3E50] leading-relaxed">
                She specializes in strategic money management, life insurance solutions for income protection, and comprehensive credit education. With a mission rooted in increasing financial literacy and building generational wealth, Shannon is passionate about empowering underserved communities.
              </p>
            </div>

            <div>
              <h3 className="text-2xl md:text-3xl font-serif text-[#0A2540] font-bold mb-6">
                Our Mission
              </h3>
              <p className="text-base md:text-lg text-[#2C3E50] leading-relaxed mb-6">
                Driven by a deep commitment to empowering individuals and families on their journey to financial freedom, Shannon focuses on equipping communities with the tools and knowledge they need to thrive.
              </p>
              <blockquote className="border-l-4 border-[#0B8FD8] pl-6 italic text-lg text-[#2C3E50]">
                "Each one, teach one" isn't just a saying—it's a mission.
              </blockquote>
            </div>

            <Button 
              className="bg-[#0B8FD8] hover:bg-[#0973B0] text-white px-8 py-3 text-base rounded-md transition-all duration-300 shadow-lg hover:shadow-xl"
              onClick={() => window.open('https://go.sbrooksassociatesllc.com/bookwithshannon', '_blank')}
            >
              Schedule a Consultation
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MeetShannon;
